<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Permissão {{ permissao.nome }}</v-toolbar-title>

        <v-spacer />
      </v-toolbar>

      <DataTableDeCrud
        :items="rotinas"
        :headers="headers"
        titulo="Rotina"
        :permissao-geral="true"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogVincularRotina()"
        @update="(indice) => abrirDialogEditarVinculoRotina(indice)"
        @delete="(indice) => abrirDialogExcluirRotina(indice)"
      >
        <template #[`item.operacoes`]="{ item }">
          {{
            item.operacoes
              .toLowerCase()
              .split(',')
              .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
              .join(', ')
          }}
        </template>
      </DataTableDeCrud>
    </v-card>

    <DialogDeVinculacaoDaRotinaComPermissao
      :show-dialog-vinculo.sync="showDialogParam"
      :permissao="permissao"
      :rotina="rotinaParam"
      :itens-rotina="itensRotina"
      :operacao="operacao"
      @confirmado="atualizarRotina"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="dialogExcluirRotina" persistent max-width="380">
      <v-card>
        <v-card-title class="headline">Remover Vínculo</v-card-title>
        <v-card-text refs="itemRotinaExclusao">
          Tem certeza que deseja remover a rotina <b> {{ itemRotinaExclusao.rotina.nome }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogExcluirRotina = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="excluirRotina">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import PermissaoService from '@/services/usuario/permissao'
import RotinaService from '@/services/usuario/rotina'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeVinculacaoDaRotinaComPermissao from './DialogDeVinculacaoDaRotinaComPermissao'
import SnackBar from '@/models/components/snackbar'
import Rotina from '@/models/rotina'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeVinculacaoDaRotinaComPermissao
  },
  props: ['showDialogSettings', 'permissao'],
  data: () => ({
    headers: [
      { text: 'Nome', value: 'rotina.descricao' },
      { text: 'Operações', value: 'operacoes' }
    ],
    rotinas: [],
    itensRotina: [],
    loading: false,
    validForm: false,
    dialog: false,
    dialogVincularRotina: false,
    showDialogParam: false,
    rotinaParam: {},
    operacao: 'adicionar',
    snackbar: new SnackBar(),
    dialogExcluirRotina: false,
    itemRotinaExclusao: {
      rotina: new Rotina(),
      operacoes: []
    },
    indiceRotinaEdicao: 0,
    indiceRotinaExclusao: 0
  }),

  watch: {
    showDialogSettings() {
      return this.showDialogSettings ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.dialog = this.showDialogSettings
      this.buscarRotinasDaPermissao(this.permissao.id)
      this.buscarTodasRotinas()
    },

    async buscarTodasRotinas() {
      try {
        const response = await RotinaService.getAll()
        this.itensRotina = response.map((item) => ({
          text: item.descricao,
          value: item.id
        }))
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar as permissões cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarRotinasDaPermissao(permissaoId) {
      try {
        const response = await PermissaoService.getAllRotinasByPermissao(permissaoId)

        this.rotinas = response.map((item) => ({
          rotina: item.rotina,
          operacoes: item.operacoes.sort().join()
        }))
      } catch (error) {
        this.snackbar.snackTextParam =
          'Não foi possível encontrar as rotinas relacionadas à esta permissão.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    atualizarRotina(rotina) {
      if (!rotina) return

      const rotinasArray = Object.values(rotina)

      rotinasArray.forEach((item) => {
        item.operacoes = item.operacoes.sort().join()

        this.operacao === 'adicionar'
          ? this.rotinas.push(item)
          : Object.assign(this.rotinas[this.indiceRotinaEdicao], item)
      })

      this.snackbar.snackTextParam = 'Rotina(s) vinculada(s) com sucesso.'
      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    async excluirRotina() {
      try {
        await PermissaoService.removeRotinaRelationship(
          this.permissao.id,
          this.itemRotinaExclusao.rotina.id
        )
        this.snackbar.snackTextParam =
          'Relacionamento da rotina com a permissão removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.rotinas.splice(this.indiceRotinaExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirRotina = false
    },

    fecharDialog() {
      this.$emit('update:showDialogSettings', false)
    },

    abrirDialogVincularRotina() {
      this.operacao = 'adicionar'
      this.rotinaParam = { rotina: new Rotina(), operacoes: ['ACESSAR'] }
      this.showDialogParam = true
    },

    abrirDialogEditarVinculoRotina(indice) {
      this.operacao = 'editar'
      this.indiceRotinaEdicao = indice
      this.rotinaParam = { ...this.rotinas[indice] }
      this.rotinaParam.operacoes = this.rotinaParam.operacoes.split(',')
      this.showDialogParam = true
    },

    abrirDialogExcluirRotina(indice) {
      this.itemRotinaExclusao = this.rotinas[indice]
      if (!this.itemRotinaExclusao.rotina.id) return

      this.indiceRotinaExclusao = indice
      this.dialogExcluirRotina = true
    }
  }
}
</script>
